import { Flex } from "@gravity-ui/uikit";
import cn from "classnames";
import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import css from "./ProductModalContent.module.scss";
export const ProductModalContentSkeleton = () => {
  const { isMobile } = useGravityDevice();

  return (
    <>
      <Flex
        direction={isMobile ? "column" : "row"}
        gap="10"
        alignItems={isMobile ? "center" : undefined}
        className={cn(css.content, isMobile && css.contentMobile)}
      >
        <Skeleton className={classNames(css.image, css.skeletonCard)} />

        <Flex
          direction="column"
          gap="5"
          grow={1}
          width={"100%"}
          className={css.content}
        >
          <Skeleton width="100%" height={300} className={css.skeletonCard} />

          <Skeleton height={50} width={"100%"} className={css.skeletonCard} />
        </Flex>
      </Flex>
    </>
  );
};
